import React from "react";
import { useState, useRef, useMemo } from "react";
import {
    Box, Typography, Avatar, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener, MenuItem, FormControl,
    TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Checkbox
} from "@mui/material";
import { FaUserCircle } from "react-icons/fa";
import { CiCalendar } from "react-icons/ci";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import CustomPagination from "components/CustomPagination";
import { LuEye, LuRefreshCw } from "react-icons/lu";
import { BiListUl } from "react-icons/bi";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import Select from "react-select";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { HiSearch } from "react-icons/hi";


const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

const RecentlyAdded = ({ data = [], onEditClick }) => {
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [selectedData, setSelectedData] = useState();
    const [allSelected, setAllSelected] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [filters, setFilters] = useState({
        Category: '',
        Status: '',
        Contractor: '',
        ReportedDate: ''
    });

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');


    const extractedCategories = Array.isArray(data) && data.length > 0
        ? [...new Set(data.map(item => item.category).filter(Boolean))]
        : [];

    const issueCategories = extractedCategories.map(category => ({
        value: category,
        label: category
    }));

    const extractedContractor = Array.isArray(data) && data.length > 0
        ? [...new Set(data.map(item => item.contractor).filter(Boolean))]
        : [];

    const issueContractor = extractedContractor.map(category => ({
        value: category,
        label: category
    }));

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = (filterType) => {
        setFilters(prev => ({
            ...prev,
            [filterType]: ''
        }));
    };

    const handleSelectChange = (selectedOption, filterType) => {
        const value = selectedOption ? selectedOption.value : '';
        setFilters(prev => ({
            ...prev,
            [filterType]: value
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleReset = () => {
        setFilters({
            Category: '',
            Contractor: '',
            ReportedDate: ''
        });
        setSearchText("")
    };

    const handleApplyFilters = () => {
        setCurrentPage(1);
        setSearchText("")
        handleClose();
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setCurrentPage(1);
    };


    const getAvatarColor = (title) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = title ? title.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const createSortHandler = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const processedData = useMemo(() => {
        let result = [...data];

        if (filters.Category) {
            result = result.filter(item => item.category === filters.Category);
        }

        if (filters.Contractor) {
            result = result.filter(item => item.contractor === filters.Contractor);
        }

        if (filters.ReportedDate) {

            result = result.filter(item => {
                if (!item.reportedDate) return false;

                try {

                    const itemDateOnly = moment(item.reportedDate).format('YYYY-MM-DD');
                    const filterDateOnly = filters.ReportedDate;
                    return itemDateOnly === filterDateOnly;

                } catch (error) {
                    console.error("Date parsing error for item:", item.id, error);
                    return false;
                }
            });
        }
        if (searchText.trim() !== "") {
            const s = searchText.toLowerCase();
            result = result.filter((item) =>
                item.category?.toLowerCase().includes(s) ||
                item.contractor?.toLowerCase().includes(s) ||
                item.actionsBy?.toLowerCase().includes(s) ||
                item.description?.toLowerCase().includes(s) ||
                item.id?.toLowerCase().includes(s)
            );
        }


        if (orderBy) {
            result = [...result].sort((a, b) => {
                const aValue = a[orderBy];
                const bValue = b[orderBy];

                if (orderBy === 'createdDate' || orderBy === 'reportedDate') {

                    const aDate = new Date(aValue);
                    const bDate = new Date(bValue);
                    return order === 'asc' ? aDate - bDate : bDate - aDate;
                }

                if (typeof aValue === 'string') {
                    return order === 'asc'
                        ? aValue.localeCompare(bValue)
                        : bValue.localeCompare(aValue);
                }

                return order === 'asc' ? aValue - bValue : bValue - aValue;
            });
        }
        return result;
    }, [data, filters, order, orderBy, searchText]);

    const hasFilters = filters.Category || filters.Contractor || filters.ReportedDate;

    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return processedData.slice(startIndex, endIndex);
    }, [processedData, currentPage, pageSize,]);

    const totalCount = processedData.length;

    const handleDeleteClick = (row) => {
        alert("View Clicked for: " + row.id);
    }



    const columns = [
        {
            name: "Issue Description",
            field: "description",
            width: "460px",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Avatar
                        sx={{
                            width: 30,
                            height: 30,
                            bgcolor: getAvatarColor(row.description),
                            color: "#fff",
                            fontSize: "14px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                        }}
                    >{row?.description?.[0] || "?"}</Avatar>
                    <Box>
                        <Typography sx={{
                            fontSize: "16px", maxWidth: "250px", fontWeight: 500, fontFamily: "Outfit", color: "#433F5E", overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>
                            {row?.description}
                        </Typography>
                    </Box>

                    <Box className="hoverButtons" sx={{ display: "none", gap: "10px" }}>
                        <Button
                            onClick={() => onEditClick(row)}
                            startIcon={<EditIcon style={{ width: 11, height: 11, fill: "#433F5E" }} />}
                            sx={{
                                backgroundColor: "#E7E7EB",
                                p: "2px 6px",
                                borderRadius: "5px",
                                fontSize: "11px",
                                fontWeight: 600,
                                textTransform: 'none'
                            }}
                        >
                            Edit
                        </Button>
                        <Button
                            onClick={() => handleDeleteClick(row)}
                            startIcon={<LuEye style={{ width: 12, height: 12 }} />}
                            sx={{
                                backgroundColor: "#E7E7EB",
                                p: "2px 6px",
                                borderRadius: "5px",
                                fontSize: "11px",
                                fontWeight: 600,
                                textTransform: 'none'
                            }}
                        >
                            Delete
                        </Button>
                    </Box>
                </Box>
            ),
        },
        {
            name: "Issue ID",
            field: "id",
        },
        {
            name: "Contractor/Consultant",
            field: "contractor",
        },
        {
            name: "Category",
            field: "category",
            renderer: (row) => (
                <Chip
                    sx={{
                        height: "23px",
                        borderRadius: "5px",
                        backgroundColor: "#E7E7EB",
                        padding: "4px 8px",
                    }}
                    label={
                        <Box sx={{
                            fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: "12px",
                            color: "#5B5772",
                            letterSpacing: "0px"
                        }}>
                            {row.category}
                        </Box>
                    }
                />
            ),
        },

        {
            name: "Workflow Status",
            field: "workflowStatus",
            renderer: (row) => (
                <Chip
                    sx={{
                        height: "20px",
                        borderRadius: "5px",
                        backgroundColor: row.workflowStatus === "Open" ? "#F8DD4E" : "#E2F6FF",
                        paddingX: "4px",
                        fontFamily: "Outfit",
                        fontWeight: 600,
                        fontSize: "12px",
                    }}
                    label={
                        <Box sx={{
                            fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: "12px",
                            color: row.workflowStatus === "Open" ? "#835101" : "#0A65E4",
                            letterSpacing: "0px"
                        }}>
                            {row.workflowStatus}
                        </Box>
                    }
                />
            )
        },
        {
            name: "Current Status",
            field: "currentStatus",
            renderer: (row) => (
                <Chip
                    sx={{
                        height: "20px",
                        borderRadius: "5px",
                        backgroundColor: "#F8DD4E",
                        paddingX: "4px",
                        fontFamily: "Outfit",
                        fontWeight: 600,
                        fontSize: "12px",
                    }}
                    label={
                        <Box sx={{
                            fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: "12px",
                            color: "#835101",
                            letterSpacing: "0px"
                        }}>
                            {row.currentStatus}
                        </Box>
                    }

                />
            )
        },
        {
            name: "Created Date",
            field: "createdDate",
            renderer: (row) => (
                <>{moment(row.createdDate).format("DD MMM YYYY")}</>
            )
        },
        {
            name: "Reported Date",
            field: "reportedDate",
            renderer: (row) => (
                <>{moment(row.reportedDate).format("DD MMM YYYY")}</>
            )
        },

        {
            name: "Actions Required By",
            field: "actionsBy",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "4px" }}>
                    <Avatar
                        sx={{
                            width: 21,
                            height: 21,
                            bgcolor: "#140F36",
                            color: "#fff",
                            fontSize: "12px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                        }}
                    >
                        {row?.actionsBy?.[0] || "?"}
                    </Avatar>
                    <Typography sx={{
                        fontFamily: "Outfit",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#5B5772",
                        letterSpacing: "0px"
                    }}>
                        {row.actionsBy}
                    </Typography>
                </Box>
            )
        },
        {
            name: "Time Impact",
            field: "timeImpact",
            renderer: (row) => (
                <Chip
                    sx={{
                        height: "24px",
                        borderRadius: "5px",
                        backgroundColor: "#FFEFEB",
                        paddingX: "8px",
                        fontFamily: "Outfit",
                        fontWeight: 600,
                        fontSize: "14px",
                    }}
                    label={
                        <Box sx={{
                            fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: "#CC0905",
                            letterSpacing: "0px"
                        }}>
                            {row.timeImpact}
                        </Box>
                    }
                />
            )
        }
    ];

    return (
        <>
            <Grid size={12}>
                <Grid container>
                    <Grid size={{ md: 8, sm: 6 }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                padding: "8px 0",
                                alignItems: "center",
                                minHeight: "40px"
                            }}
                        >
                            {!hasFilters && (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <HiSearch size={20} color="#48535B" />
                                    <input
                                        type="text"
                                        placeholder="Search Users"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        style={{
                                            border: "none",
                                            outline: "none",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            fontFamily: "Outfit",
                                            color: "#252C32",
                                            background: "transparent",
                                            lineHeight: "24px",
                                            letterSpacing: "-0.1px",
                                        }}
                                    />
                                </Box>
                            )}
                            {filters.Category && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Category:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {issueCategories.find(cat => cat.value === filters.Category)?.label || filters.Category}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('Category')}
                                />
                            )}


                            {filters.Contractor && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Contractor:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {filters.Contractor}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('Contractor')}
                                />
                            )}


                            {filters.ReportedDate && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Reported Date:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {moment(filters.ReportedDate).format('DD-MM-YYYY')}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('ReportedDate')}
                                />
                            )}
                        </Stack>
                    </Grid>
                    <Grid size={{ md: 4, sm: 6 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: 'end',
                                p: "8px 0px"
                            }}
                        >
                            <IconButton
                                ref={anchorRef}
                                onClick={handleToggle}
                            >
                                <MdOutlineFilterAlt size={24} color="#48535B" />
                            </IconButton>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                placement="bottom-end"
                                transition
                                disablePortal={false}
                                sx={{ zIndex: 2000 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {({ TransitionProps }) => (
                                    <Grow {...TransitionProps}>
                                        <Paper
                                            sx={{
                                                mt: 1,
                                                p: 2,
                                                borderRadius: 1,
                                                boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                width: 300,
                                            }}
                                        >
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <Box>
                                                    <Grid container spacing={2}>
                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Category</Typography>
                                                            <Select
                                                                name="Category"
                                                                options={issueCategories}
                                                                placeholder="Select Category"
                                                                onChange={(option) => handleSelectChange(option, "Category")}
                                                            />

                                                        </Grid>

                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Contractor</Typography>

                                                            <Select
                                                                name="Contractor"
                                                                options={issueContractor}
                                                                placeholder="Select Contractor"
                                                                onChange={(option) => handleSelectChange(option, "Contractor")}
                                                            />

                                                        </Grid>

                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Reported Date</Typography>
                                                            <TextField
                                                                type="date"
                                                                name="reportedDate"
                                                                value={filters.ReportedDate || ''}
                                                                onChange={(e) => {
                                                                    const selectedDate = e.target.value;
                                                                    setFilters((prev) => ({
                                                                        ...prev,
                                                                        ReportedDate: selectedDate,
                                                                    }));
                                                                }}
                                                                onClick={(e) => {
                                                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                    if (input) input.showPicker?.();
                                                                }}
                                                                fullWidth
                                                                sx={{
                                                                    "& input::-webkit-calendar-picker-indicator": {
                                                                        display: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& input[type='date']": {
                                                                        appearance: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": {
                                                                            border: "none",
                                                                        },
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                            {calenderSVG}
                                                                        </Box>
                                                                    ),
                                                                    sx: {
                                                                        backgroundColor: "#E7E7EB",
                                                                        height: "40px",
                                                                        width: { xs: "100%", md: "100%" },
                                                                        borderRadius: "5px",
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid size={12}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Button onClick={handleReset}
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "#F15744",
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        borderRadius: "25px",
                                                                        fontWeight: 500,
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}>
                                                                    Reset
                                                                </Button>
                                                                <Button
                                                                    type="button"
                                                                    onClick={handleApplyFilters}
                                                                    variant="contained"
                                                                    sx={{
                                                                        backgroundColor: "#00344C",
                                                                        borderRadius: "25px",
                                                                        textTransform: "none",
                                                                        fontWeight: 500,
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        color: "#FFFFFF",
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}
                                                                >
                                                                    Apply
                                                                </Button>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                            <IconButton>
                                <BiListUl size={24} color="#48535B" />
                            </IconButton>
                            <IconButton>
                                <MdOutlineFileDownload size={24} color="#48535B" />
                            </IconButton>
                            <IconButton>
                                <LuRefreshCw size={20} color="#48535B" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <TableComponent
                data={paginatedData}
                isLoading={loading}
                columns={columns}
                order={order}
                orderBy={orderBy}
                createSortHandler={createSortHandler}

            />
            <CustomPagination
                totalCount={totalCount}
                pageSize={pageSize}
                page={currentPage}
                onPageChange={handlePageChange}
                setCurrentPage={setCurrentPage}
                onPageSizeChange={handlePageSizeChange}
            />
        </>
    );
}

export default RecentlyAdded;